const DEFAULT_INTEGRATIONS_CONFIG = {
  All: true,
};

export { DEFAULT_INTEGRATIONS_CONFIG };
